module.exports = __webpack_public_path__ + "img/DE00286.6eba2af3.png";